import Alpine from "alpinejs"

Alpine.data("vaccinationLocations", (data = null) => ({
    cantons: data,
    selectedCanton: null,

    init() {
        this.$el.addEventListener("dropdown:add-item", (event) => {
            const { id, identifier } = event.detail
            if (id === "cantons") {
                if (this.selectedCanton?.id !== identifier) {
                    this.selectedCanton = this.cantons.find((canton) => identifier === canton.identifier) ?? null
                } else {
                    this.selectedCanton = null
                }
            }
        })

        this.$el.addEventListener("dropdown:clear-items", (event) => {
            const { id } = event.detail
            if (id === "cantons") {
                this.selectedCanton = null
            }
        })
    },
}))
